// extracted by mini-css-extract-plugin
export default {"download-template":"UsersTab_download-template__BJh3s","icon":"UsersTab_icon__gyFXv"};